<template>
         <router-link :to="{ name: 'CategoryPage', params: { c: $route.params.q, s: cat.slug } }" class="subcategory">
           <div class="prod-img-container">
              <img loading="lazy" :src=" '/upload/category-images/' + cat.img " width="1000" height="1000">
              <span class="link-label ">{{cat.name}}</span>
           </div>
          </router-link>
</template>
<script>
  export default {
    name: 'Productpreview',
    props: { 
      cat: {
        type: Object,
        required: false,
        default: () => [],
      }
      },
    data: () => {
      return {
         image: ""
      }
    },    
    mounted: function(){
      this.image = '/upload/category-images/' + this.cat.img;
    }
  }
</script>
<style>
  .prod-img-container { overflow: hidden; width: 100%; }
  .prod-img-container img { display: block; width: 100%; transform: scale(1.01); transition: transform 0.3s ease-in-out; background: #eee; }
  .prod-img-container img[src=""] { padding-top: 100%; visibility: hidden; }
  .prod-img-container:hover img { transform: scale(1.05); transition: transform 0.3s ease-in-out; }
</style>